const sectionItemsGrid06Css = `
[data-type='section-items-grid-06'] .items-grid-wrapper {
  background-color: var(--background-color, #ffffff);
}

[data-type='section-items-grid-06'] .items-grid-wrapper[data-background-image='true'] {
  background-image: url('/uploads/images/2026/03/31/image-69cb8abb6eef8a947b7f3b8b.png?w=1200&h=50&q=80');
  background-position: top center;
  background-repeat: repeat-y;
  background-size: 100%;
}

[data-type='section-items-grid-06'] .items-grid-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-items-grid-06'] .items-grid-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-items-grid-06'] .items-grid-content {
  padding-inline: 8px;
}

[data-type='section-items-grid-06'] .items-grid-header:not(:empty) {
  margin-bottom: 24px;
}

[data-type='section-items-grid-06'] .items-grid-header h1,
[data-type='section-items-grid-06'] .items-grid-header h2,
[data-type='section-items-grid-06'] .items-grid-header h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
  color: var(--text-color, #000000);
}

[data-type='section-items-grid-06'] .items-grid-header h1:last-child,
[data-type='section-items-grid-06'] .items-grid-header h2:last-child,
[data-type='section-items-grid-06'] .items-grid-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-06'] .items-grid-header p {
  font-size: 18px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
  color: var(--text-color, #000000);
}

[data-type='section-items-grid-06'] .items-grid-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-06'] .items-grid-header figure {
  overflow-x: auto;
  overflow-y: hidden;
}

[data-type='section-items-grid-06'] .items-grid-list {
  --items-gap: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: var(--items-gap);
}

[data-type='section-items-grid-06'] .items-grid-item {
  --item-basis-desktop: calc(
    (100% - (var(--items-per-row-desktop, 5) - 1) * var(--items-gap)) / var(--items-per-row-desktop, 5)
  );
  --item-basis-mobile: calc(
    (100% - (var(--items-per-row-mobile, 2) - 1) * var(--items-gap)) / var(--items-per-row-mobile, 2)
  );

  flex: 0 0 var(--item-basis-desktop);
  max-width: var(--item-basis-desktop);

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  border-radius: var(--card-border-radius, 12px);
  padding: 20px 10px;
  background-color: var(--card-background-color, #14a16c);
  border: 1px solid #d7d7d7;
}

[data-type='section-items-grid-06'] .items-grid-item-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--item-image-width-desktop, 60px);
  height: auto;
}

[data-type='section-items-grid-06'] .items-grid-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-items-grid-06'] .items-grid-item-text {
  flex: 1;
}

[data-type='section-items-grid-06'] .items-grid-item-text h1,
[data-type='section-items-grid-06'] .items-grid-item-text h2,
[data-type='section-items-grid-06'] .items-grid-item-text h3 {
  font-size: 18px;
  line-height: normal;
  margin: 0 0 8px 0 !important;
  color: var(--card-text-color, #ffffff);
}

[data-type='section-items-grid-06'] .items-grid-item-text h1:last-child,
[data-type='section-items-grid-06'] .items-grid-item-text h2:last-child,
[data-type='section-items-grid-06'] .items-grid-item-text h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-06'] .items-grid-item-text p {
  font-size: 14px;
  margin: 0 0 4px 0 !important;
  line-height: normal;
  color: var(--card-text-color, #ffffff);
}

[data-type='section-items-grid-06'] .items-grid-item-text p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-items-grid-06'] .items-grid-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-items-grid-06'] .items-grid-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-items-grid-06'] .items-grid-header h1,
  [data-type='section-items-grid-06'] .items-grid-header h2,
  [data-type='section-items-grid-06'] .items-grid-header h3 {
    font-size: 20px;
  }

  [data-type='section-items-grid-06'] .items-grid-header p {
    font-size: 14px;
  }

  [data-type='section-items-grid-06'] .items-grid-header figure {
    width: 98% !important;
  }

  [data-type='section-items-grid-06'] .items-grid-list {
    --items-gap: 12px;
  }

  [data-type='section-items-grid-06'] .items-grid-item {
    flex-basis: var(--item-basis-mobile);
    max-width: var(--item-basis-mobile);
  }

  [data-type='section-items-grid-06'] .items-grid-item-image {
    width: var(--item-image-width-mobile, 60px);
  }

  [data-type='section-items-grid-06'] .items-grid-item-text h1,
  [data-type='section-items-grid-06'] .items-grid-item-text h2,
  [data-type='section-items-grid-06'] .items-grid-item-text h3 {
    font-size: 16px;
  }
}
`;
export default sectionItemsGrid06Css;
